import React, { Component } from 'react';
import { withRouter } from 'react-router';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import queryString from 'query-string';
import { Container, Col } from 'reactstrap';

import SearchInput from './SearchInput';
import Features from './Landing/Features';
import Logo from './ui-elements/Logo';
import Arrow from './ui-elements/Arrow';

class Main extends Component {

  componentDidMount() {
    const params = queryString.parse(this.props.location.search);
    const email = params['email'];
    if(email){
        window.heap.identify(email);
        this.props.history.push('/');
    }
  }

  render() {
    return (
      <div className='d-flex flex-column justify-content-center' style={{flex: 1}}>

        <div className='d-flex flex-column' style={{minHeight: '100vh'}}>

          <Container className='text-center d-flex align-items-center py-5' style={{flex: 1}}>
            <Col xs="12" md="6" className='mainSearch mx-auto my-5 pb-5'>
              <Logo size="xl" className='mb-4 mb-md-5' link={false}/>
              <p className='d-none mb-4 mb-md-5 text-muted' style={{ fontSize: '1.4rem' }}><strong>paul</strong> open search</p>
              <SearchInput className="shadow-sm" suggestions />
              <div className='mt-4 mb-5 pb-5'>
                <small className='text-muted'>
                  Die Plattform für politische Hintergründe.<br />
                  <AnchorLink href="#features">
                    Mehr erfahren.
                  </AnchorLink>
                </small>
              </div>
            </Col>
          </Container>

          <Arrow href="features" />

        </div>

        <div id="features">
          <Features />
        </div>

      </div>
    )
  }
}

export default withRouter(Main);



// WEBPACK FOOTER //
// ./src/components/Main.js